export default "__VITE_ASSET__CQXfmLSf__"